import { createAsyncThunk } from "@reduxjs/toolkit";
import { makeRequest } from "../../utilities/api";

export const getNotifications = createAsyncThunk("notifications/list", async (_, { rejectWithValue }) => makeRequest("/notifications/", "GET", null, rejectWithValue));

export const getUnreadNotifications = createAsyncThunk("notifications/unread", async (_, { rejectWithValue }) => makeRequest("/notifications/?is_read=false", "GET", null, rejectWithValue));

export const readNotificationsAction = createAsyncThunk("notifications/read", async (value, { rejectWithValue }) => makeRequest("/notifications/read/", "PATCH", value, rejectWithValue));
